import parse from 'html-react-parser'
export default function GalleryItem(props) {
  const {img, name, rarity} = props

  function filterRarityClassName(rarity) {
    switch (rarity) {
      case 'UNIQUE':
        return 'rarityUNIQUE'
      case 'MYTHIC':
        return 'rarityMYTHIC'
      case 'LEGENDARY':
        return 'rarityLEGENDARY'
      case 'EPIC':
        return 'rarityEPIC'
      case 'RARE':
        return 'rarityRARE'
      case 'COMMON':
        return 'rarityCOMMON'
      default:
        return 'rarityCOMMON'
    }
  }
  return (
    <div className='galleryItemContainer'>
      <img src={img} alt='img' />
      <div className='galleryItemInfo'>
        <div className='galleryItemName'>{parse(name)}</div>
        <div className={'rarityItem ' + filterRarityClassName(rarity)}>{rarity}</div>
      </div>
    </div>
  )
}